import { render, staticRenderFns } from "./basecost-setting-add.vue?vue&type=template&id=567d6d07&"
import script from "./basecost-setting-add.vue?vue&type=script&lang=ts&"
export * from "./basecost-setting-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports